import {
  GraphResponse,
  TableResponse,
} from '../pages/dashboard/dashboardInterface';
import { get, getExcelDownload } from './apiService';

export const getAllGuestBymonth = async (id: string) => {
  return await get('/dashboard/facility/' + id + '/checked-in-users-count');
};

export const getAllTotalSupportBuisnessCount = async (id: string) => {
  return await get(
    '/dashboard/facility/' +
      id +
      '/support-business-count-around-facility?distanceInKm=20'
  );
};

export const getTotalBookingsDetails = async (
  params: any
): Promise<GraphResponse> => {
  return await get('/toristy/dashboard/graph', params);
};

export const getBookingSummary = async (
  params: any
): Promise<TableResponse> => {
  return await get('/toristy/dashboard/data', params);
};
export const getDownloadTableData = async (
  params: any
): Promise<TableResponse> => {
  return await getExcelDownload('/toristy/dashboard', params);
};
